import React, { useState, useEffect } from 'react';
import SearchParameters from './SearchParameters';
import ItemDetailsCard from './ItemDetailsCard';
import { useFetchItemDetails, useResetItemDetails } from './redux/hooks';
import './ItemAvailabilityInquiry.js';
import axios from '../../features/common/redux/interceptor.js';
import { useGetAuthrization } from '../home/redux/hooks';
import { redirectUrl } from '../../common/apiConfig';
import {AUTH_ERROR_MSG, SIA_IA_STI_SEARCH_PARAMS_KEY} from '../../common/constants';

export default function ItemAvailabilityInquiry() {
  const [hasSearched, setHasSearched] = useState(false);
  const { itemDetails, fetchItemDetails, fetchItemDetailsPending, fetchItemDetailsError } = useFetchItemDetails();
  const { resetItemDetails } = useResetItemDetails();
  const { auth } = useGetAuthrization();

  // Check for auth errors and redirect
  useEffect(() => {
    if (!auth.cognitoIdToken || fetchItemDetailsError === AUTH_ERROR_MSG) {
      sessionStorage.clear();
      window.location.assign(redirectUrl);
    }
  }, [auth.cognitoIdToken, fetchItemDetailsError]);

  useEffect(() => {
    console.log('ItemAvailabilityInquiry - State:', {
      itemDetails,
      fetchItemDetailsPending,
      fetchItemDetailsError
    });
  }, [itemDetails, fetchItemDetailsPending, fetchItemDetailsError]);

  // Auto-search with saved parameters on mount
  useEffect(() => {
    const savedParams = sessionStorage.getItem(`${SIA_IA_STI_SEARCH_PARAMS_KEY}_item`);
    if (savedParams) {
      try {
        const parsedParams = JSON.parse(savedParams);
        handleSearch(parsedParams);
      } catch (error) {
        console.error('Error loading saved search:', error);
      }
    }
  }, []); // eslint-disable-line

  const handleSearch = (values) => {
    console.log('ItemAvailabilityInquiry - Search values:', values);
    const { site, itemNumber } = values;
    
    setHasSearched(true);
    fetchItemDetails({
      // siteNumber: site,
      siteNumber: String(site).split('-')[0].trim(),
      itemNumber: itemNumber,
    });

    // Save to session storage
    //sessionStorage.setItem(`${SIA_IA_STI_SEARCH_PARAMS_KEY}_item`, JSON.stringify(values));
  };

  const handleReset = () => {
    console.log('ItemAvailabilityInquiry - handleReset');
    setHasSearched(false);
    resetItemDetails(); // Clear data and error from Redux state
  };

  return (
    <div className="item-availability-inquiry">
      <SearchParameters type="item" onSearch={handleSearch} onReset={handleReset} />
      <div className="item-details-section">
        <h3>Item Availability Details</h3>
        <ItemDetailsCard 
          data={itemDetails}
          loading={fetchItemDetailsPending}
          error={fetchItemDetailsError}
          hasSearched={hasSearched}
        />
      </div>
    </div>
  );
}


